import anime, { AnimeInstance } from 'animejs'
import React, { FC, ReactNode, useEffect, useRef } from 'react';

interface ISlideInOutAnimation {
  children: ReactNode;
  variant: 'in' | 'out'

}

export const SlideInOut: FC<ISlideInOutAnimation> = ({children,variant}) => {
  const animationRef = useRef<AnimeInstance>(anime({}));

  useEffect(() => {
    if(variant === 'in') {
        slideIn()
    }

    if(variant === 'out') {
        slideOut();
    }
    return (() => {
        slideOut();
    } )
  },[])

  const slideIn = () => {
    return  animationRef.current = anime({
        targets: '.slideInOut',
        opacity: [0,1],
        translateY: [20,0],
        delay: anime.stagger(200, {from: 'center'})
    })
  }

  const slideOut = () => {
    return  animationRef.current = anime({
        targets: '.slideInOut',
        opacity: [1,0],
        translateY: [0,20],
        delay: anime.stagger(100, {from: 'center'})
    })
  }

  return <div className='slideInOut'>{children}</div>;
};

export default SlideInOut;
